import { Link } from "gatsby"
import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { useTranslation } from "react-i18next"

import logo from "@images/svg/logo-alma-insights-inverted.svg"
import facebook from "@images/svg/social-facebook.svg"
import linkedIn from "@images/svg/social-linkedin.svg"
import twitter from "@images/svg/social-twitter.svg"
import "@lang/i18n"

import styles from "./Footer.module.scss"

const Footer = ({
  siteTitle,
  currentLanguage,
  open,
  siteSettings,
  footerMenu,
}) => {
  const languageRoot = "/"
  /*
  const languageRoot =
    currentLanguage === "fi" ? "/" : "/" + currentLanguage.toLowerCase() + "/"
  */
  const { t } = useTranslation()

  const normalizeMenuItem = (node) => {
    node = node?.node ? node.node : node

    return {
      label: node?.label || "",
      path: node?.path || "#",
      parentId: node?.parentId || null,
      childItems: node?.childItems?.nodes
        ? node.childItems.nodes.map(normalizeMenuItem)
        : [],
    }
  }

  const footerMenuItems = footerMenu.map(normalizeMenuItem).filter((item) => {
    return item
  })

  const fbLink = siteSettings.facebookUrl
  const lnLink = siteSettings.linkedinUrl
  const twLink = siteSettings.twitterUrl

  return (
    <footer className={`${styles.footer} ${open ? "nav-state--active" : ""}`}>
      <div className="container">
        <Row className="mobile-bottom-margins tablet-bottom-margins">
          <Col lg={{ span: 3 }}>
            <Link className={styles.brand} to={languageRoot}>
              <img src={logo} width="300" height="80" alt={siteTitle} />
            </Link>
          </Col>

          <Col lg={{ span: 4 }}>
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{ __html: siteSettings.footerContentFi }}
            ></div>
          </Col>
          <Col lg={{ span: 5 }}>
            <ul className={styles.list}>
              {footerMenuItems.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        <div className={styles.bottom}>
          <div className={styles.addresses}>
            <span>
              {t("Postal address")} / {siteSettings.postalAddress}
            </span>
            <span>
              {t("Visiting address")} / {siteSettings.visitingAddress}
            </span>
          </div>
          <div className={styles.socialMedia}>
            <h2 className="screen-reader-text">{t("Follow us")}</h2>
            <ul>
              {fbLink && (
                <li>
                  <a href={fbLink} target="_blank" rel="noopener noreferrer">
                    <img src={facebook} alt="Facebook" />
                  </a>
                </li>
              )}
              {lnLink && (
                <li>
                  <a href={lnLink} target="_blank" rel="noopener noreferrer">
                    <img src={linkedIn} alt="LinkedIn" />
                  </a>
                </li>
              )}
              {twLink && (
                <li>
                  <a href={twLink} target="_blank" rel="noopener noreferrer">
                    <img src={twitter} alt="Twitter" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  footerMenu: [],
  areas: [],
  currentLanguage: "fi",
}

export default Footer
